import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import { Button } from "@mui/material";
import { useState, type FC } from "react";
import { useTranslation } from "react-i18next";
import { useDialog } from "../../../utils/hooks/use-dialog";
import { FileUpload } from "../file-upload";
import { useCreateAssetCallback } from "../hooks/use-upsert-asset";
import type { Asset } from "../server/digital-asset-service";

export const AssetPickerAddNew: FC<{
  setSelectedAsset: (asset: Asset) => void;
}> = ({ setSelectedAsset }) => {
  const { t } = useTranslation();
  const [saving, setSaving] = useState<boolean>(false);
  const uploadModal = useDialog();
  const createAsset = useCreateAssetCallback();

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        startIcon={<AddCircleOutline data-testid="AddCircleOutlineIcon" />}
        data-analytics-id="content-library-modal-upload"
        onClick={() => uploadModal.setOpen(true)}
      >
        {t("Upload")}
      </Button>
      <FileUpload
        allowedFileTypes={["pdf", "image", "video"]}
        helperText={t(
          "This will be saved in your Content Library under the category “Uploaded Files”",
        )}
        renderActions={({ handleSave }) => {
          return (
            <Button
              loading={saving}
              data-analytics-id="content-library-modal-upload-ok"
              onClick={() => {
                setSaving(true);
                void handleSave().finally(() => setSaving(false));
              }}
            >
              {t("Insert image")}
            </Button>
          );
        }}
        onSuccess={(_, asset) => {
          setSelectedAsset(asset);
          uploadModal.setOpen(false);
        }}
        open={uploadModal.open}
        heading={""}
        onClose={() => uploadModal.setOpen(false)}
        onCancel={() => uploadModal.setOpen(false)}
        onOpen={() => {}}
        onSave={createAsset}
      />
      {}
    </>
  );
};
